// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-group[data-v-5013e5b6] {\n  margin-bottom: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
